import { HttpRequest } from '@angular/common/http';

export function isIeCall(req: HttpRequest<unknown>): boolean {
  return req.url.includes('/api');
}

export function isRefreshTokenCall(req: HttpRequest<unknown>): boolean {
  return req.headers.has('refresh-token');
}

export function isTfaVerifyCall(req: HttpRequest<unknown>): boolean {
  return req.url.includes('/admin/users/tfa/verify');
}
